module.exports = __webpack_public_path__ + "assets/img/7754eb00537c50e1abfe290d31bd7066.png";